import React, { useEffect, useState } from "react";
import axios from "axios";

const Card = ({ children, className, style }) => (
  <div className={`card ${className || ""}`} style={style}>
    {children}
  </div>
);

const CardContent = ({ children, className }) => (
  <div className={`card-content ${className || ""}`}>{children}</div>
);

const ScrollArea = ({ children, className }) => (
  <div className={`scroll-area ${className || ""}`}>{children}</div>
);

const Badge = ({ children }) => <span className="badge">{children}</span>;

const statusColumns = ["قائمة المهام", "قيد التنفيذ", "مهام منجزة", "مؤجل"];

const getWeeksAgo = (dateString) => {
  const created = new Date(dateString);
  const now = new Date();
  const msInWeek = 7 * 24 * 60 * 60 * 1000;
  return Math.floor((now - created) / msInWeek);
};

export default function App() {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const [tasks, setTasks] = useState([]);

  const PASSWORD = "locate.sa"; // 🔒 Set your password here

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (passwordInput === PASSWORD) {
      setIsAuthorized(true);
      localStorage.setItem("isAuthorized", "true");
      localStorage.setItem("authTime", Date.now().toString());
    } else {
      alert("كلمة المرور غير صحيحة");
    }
  };

  const fetchTasks = async () => {
    try {
      const response = await axios.get(
        "https://reports.locate.sa/items/development_dashboard",
        {
          headers: {
            Authorization: "Bearer rDH3PuPBTTqXpULkm6xXIJhOb1k4nR_w",
          },
        }
      );
      setTasks(response.data.data || []);
    } catch (error) {
      console.error("خطأ في تحميل المهام:", error);
    }
  };
  useEffect(() => {
    const savedAuth = localStorage.getItem("isAuthorized");
    const savedTime = localStorage.getItem("authTime");

    if (savedAuth && savedTime) {
      const now = Date.now();
      const saved = parseInt(savedTime, 10);
      const daysPassed = (now - saved) / (1000 * 60 * 60 * 24);
      if (daysPassed < 30) {
        setIsAuthorized(true);
      } else {
        localStorage.removeItem("isAuthorized");
        localStorage.removeItem("authTime");
      }
    }
  }, []);
  useEffect(() => {
    if (isAuthorized) {
      fetchTasks();
      const interval = setInterval(fetchTasks, 60000);
      return () => clearInterval(interval);
    }
  }, [isAuthorized]);

  const formatDate = (isoDate) => {
    if (!isoDate) return "";

    const date = new Date(isoDate);
    const formatter = new Intl.DateTimeFormat("en-GB", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "UTC", // assuming +03 is already applied
    });

    let formatted = formatter.format(date);
    formatted = formatted.replace(",", "").replace(/\//g, "-");
    return formatted.replace(/(am|pm)/i, (match) => match.toUpperCase());
  };

  if (!isAuthorized) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h2>PASSCODE</h2>
        <form onSubmit={handlePasswordSubmit}>
          <input
            type="password"
            value={passwordInput}
            onChange={(e) => setPasswordInput(e.target.value)}
            style={{ padding: "8px", fontSize: "16px" }}
          />
          <button
            type="submit"
            style={{ marginLeft: "8px", padding: "8px 16px" }}
          >
            Login
          </button>
        </form>
      </div>
    );
  }

  return (
    <div className="dashboard" dir="rtl">
      {statusColumns.map((status) => (
        <div
          key={status}
          className="column"
          style={{
            backgroundColor: status === "مهام منجزة" ? "#1b1f3b" : "#1E283B",
          }}
        >
          <div className="column-title-wrapper">
            <span className="task-count">
              {tasks.filter((task) => task.status === status).length}
            </span>
            <span className="column-title-text">{status}</span>
          </div>
          <ScrollArea>
            {tasks
              .filter((task) => task.status === status)
              .map((task) => (
                <Card key={task.id} className="task-card" style={{
                  background: `${getWeeksAgo(task.date_created) > 5 && status !== "مهام منجزة" ? "#E93C47" : "#6366F1"
                    }`,
                }}>
                  {status !== "مهام منجزة" && getWeeksAgo(task.date_created) > 0 && getWeeksAgo(task.date_created) < 10 ? (
                    <div className="week-circle">
                      {getWeeksAgo(task.date_created)}w
                    </div>
                  ) : null}

                  <CardContent>
                    <div className="task-title">{task.title}</div>
                    <div className="task-meta">
                      {task.department} • {task.type}
                    </div>
                    <div className="task-footer">
                      <Badge>{task.priority}</Badge>
                      <span
                        className="assignee"
                        style={{
                          color:
                            new Date() - new Date(task.date_created) >
                              30 * 24 * 60 * 60 * 1000
                              ? "#F59E0B"
                              : "#fff",
                        }}
                      >
                        {formatDate(task.date_created)}
                      </span>
                    </div>
                  </CardContent>
                </Card>
              ))}
          </ScrollArea>
        </div>
      ))}

      <style>{`
        html, body{
          background:#030711;
          color:#FFF;
        }
        .dashboard {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 16px;
          padding: 16px;
        }

        .column {
          flex:1;
          background-color: #1E283B;
          border-radius: 12px;
          padding: 12px;
          height: 92vh;
          display: flex;
          flex-direction: column;
        }

        .column-title {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 12px;
        }

        .scroll-area {
          overflow-y: auto;
          flex: 1;
        }

        .card {
          background-color: #6366F1;
          border-radius: 10px;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
          margin-bottom: 12px;
        }

        .card-content {
          padding: 12px;
        }

        .task-title {
          font-weight: bold;
          margin-bottom: 6px;
          max-width: 90%;
        }

        .task-meta {
          font-size: 14px;
          color: #fff;
          margin-bottom: 6px;
        }

        .task-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .badge {
          background-color: #e0ebff;
          color: #2c5bcf;
          font-size: 12px;
          padding: 4px 8px;
          border-radius: 6px;
        }

        .assignee {
          font-size: 12px;
          color: #fff;
          direction: ltr;
        }
        .week-circle {
          position: absolute;
          top: 8px;
          left: 8px;
          background-color:rgb(242, 236, 232);
          color: #303085;
          font-size: 12px;
          font-weight: bold;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }
        .task-card {
          position: relative;
        }
        .column-title-wrapper {
          position: relative;
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 12px;
          height: 24px;
        }

        .task-count {
          position: absolute;
          left: 8px;
          top: 0;
          color: #FACC15;
          font-weight: bold;
        }

        .column-title-text {
          display: block;
          text-align: right;
          padding-right: 10px; /* creates space so number doesn't overlap */
        }
      `}</style>
    </div>
  );
}
